import { Typography } from '@material-ui/core';

const SectionHeader = ({
  title,
  subtitle,
  className = '',
  titleWeight = 'bold',
  titleColor = 'text-black',
  subtitleColor = 'text-black',
  subtitleGap = 'mb-4',
  component = 'h2',
}) => {
  const fontWeight =
    titleWeight === '800'
      ? 800
      : titleWeight === 'bold'
      ? 'bold'
      : titleWeight === 'normal'
      ? 'normal'
      : titleWeight;

  return (
    <div className={`text-center mb-12 ${className}`}>
      <Typography
        variant={component === 'h1' ? 'h2' : 'h3'}
        component={component}
        className={`${subtitle ? subtitleGap : 'mb-4'} ${titleColor}`}
        style={{ fontWeight }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body1" component="p" className={`${subtitleColor} font-normal`}>
          {subtitle}
        </Typography>
      )}
    </div>
  );
};

export default SectionHeader;
